import React from 'react';
import { Outlet } from 'react-router-dom';
import './AuthLayout.css';

const AuthLayout = () => {
    const features = [
        {
            icon: (
                <svg className="custom-icon scanning-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="3" y1="5" x2="3" y2="19" strokeWidth="2.5" />
                    <line x1="7" y1="5" x2="7" y2="19" strokeWidth="1.5" />
                    <line x1="11" y1="5" x2="11" y2="19" strokeWidth="3" />
                    <line x1="16" y1="5" x2="16" y2="19" strokeWidth="1.5" />
                    <line x1="20" y1="5" x2="20" y2="19" strokeWidth="2" />
                    <line className="scan-beam" x1="1" y1="12" x2="23" y2="12" stroke="#FFFFFF" strokeWidth="2.5" />
                </svg>
            ),
            title: 'Real-time Scanning',
            description: 'Instant barcode recognition'
        },
        {
            icon: (
                <svg className="custom-icon secure-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    <rect className="lock-body" x="9" y="11" width="6" height="5" rx="1" />
                    <path className="lock-shackle" d="M10 11V9a2 2 0 0 1 4 0v2" />
                </svg>
            ),
            title: 'Secure & Reliable',
            description: 'Enterprise-grade security'
        },
        {
            icon: (
                <svg className="custom-icon speed-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                    <path className="speed-arc arc-1" d="M18 4a9 9 0 0 1 3 8" strokeDasharray="3,3" />
                    <path className="speed-arc arc-2" d="M6 20a9 9 0 0 1-3-8" strokeDasharray="3,3" />
                </svg>
            ),
            title: 'Fast Processing',
            description: 'Lightning-fast performance'
        }
    ];

    return (
        <div className="auth-layout">
            <div className="auth-left">
                <Outlet />
            </div>
            <div className="auth-right">
                <div className="ambient-glow ambient-1"></div>
                <div className="ambient-glow ambient-2"></div>
                <video
                    className="auth-video-bg"
                    autoPlay
                    loop
                    muted
                    playsInline
                    ref={(el) => { if (el) el.playbackRate = 1.5; }}
                >
                    <source src={`${process.env.PUBLIC_URL}/static/media/scanner-animation.mp4`} type="video/mp4" />
                    <source src={`${process.env.PUBLIC_URL}/assets/scanner-animation.mp4`} type="video/mp4" />
                </video>
                <div className="right-content">
                    <div className="hero-section">
                        <h1 className="hero-title">
                            Scan smarter. Work faster.
                        </h1>
                        <p className="hero-subtitle">
                            Transform your workflow with intelligent barcode management
                        </p>
                    </div>

                    <div className="features-grid">
                        {features.map((feature, index) => (
                            <div key={index} className="feature-card">
                                <div className="feature-icon">{feature.icon}</div>
                                <h3 className="feature-title">{feature.title}</h3>
                                <p className="feature-description">{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;
